import React from "react";
import { Controller } from "react-hook-form";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormGroup,
  Grid,
} from "@mui/material";

const CheckboxGroupRHF = ({
  name,
  control,
  options = [],
  required = false,
  disabled = false,
}) => {
  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          const handleChange = (val) => {
              // Only allow one selection at a time
              if (field.value === val) {
                field.onChange(null); // uncheck
              } else {
                field.onChange(val); // set single value
              }
          };

          return (
            <Grid id="top-row" container>
              {options.map((opt) => {
                const checked = field.value === opt.value;
                return (
                  <Grid item xs={12} lg={opt.md || 6} key={opt.value}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checked}
                          disabled={disabled}
                          onChange={() => handleChange(opt.value)}
                        />
                      }
                      label={opt.label}
                    />
                  </Grid>
                );
              })}
              {error && <FormHelperText error>{error.message}</FormHelperText>}
            </Grid>
          );
        }}
      />
    </FormGroup>
  );
};

export default CheckboxGroupRHF;
